/**
 * /despre-nav — migrated from public/js/about.js.
 *
 * Animatie counters (.about-counter, .about-counter2, etc.) cand intra in viewport.
 * Numarul tot creste de la 0 la valoarea tinta pe ~1 secunda.
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    let sleeping = false;
    const c1 = $('.about-counter')  as HTMLElement | null;
    const c2 = $('.about-counter2') as HTMLElement | null;
    const c3 = $('.about-counter3') as HTMLElement | null;
    const c4 = $('.about-counter4') as HTMLElement | null;
    if (!c1 || !c2 || !c3 || !c4) return;

    function countersInView(): boolean {
        const docViewTop = window.scrollY;
        const docViewBot = docViewTop + window.innerHeight;
        const elemTop    = c1!.offset().top;
        const elemBot    = elemTop + 30;
        return elemBot <= docViewBot && elemTop >= docViewTop;
    }

    function anim(el: HTMLElement, count: number): void {
        let i = 0;
        const n = (count / 1000) * 10;
        const t = window.setInterval(() => {
            if (i >= count) window.clearInterval(t);
            el.textContent = String(Math.floor(i));
            i += n;
        }, 10);
    }

    function startCounters(): void {
        anim(c1!, 30000);
        anim(c2!, 45000);
        anim(c3!, 20000);
        anim(c4!, 22);
    }

    if (countersInView()) {
        sleeping = true;
        startCounters();
    }

    window.addEventListener('scroll', () => {
        if (sleeping) return;
        sleeping = true;
        setTimeout(() => {
            if (countersInView()) startCounters();
            else sleeping = false;
        }, 100);
    });
});
